module.exports = __webpack_public_path__ + "img/ios-screen.85cdfa2c.png";